import React from "react";
import { Overlay, Popover } from "react-bootstrap";
import SmuBadge from "../../../utils/smu-badge/SmuBadge";

const SmuPopupTb = ({
  open,
  target,
  popoverRef,
  children,
  badgeColor,
  title,
  all,
  noData,
}) => {
  const handleAll = () => {
    if (!all) return;
    all();
  };

  return (
    <Overlay
      show={open}
      target={target}
      placement="bottom"
      container={popoverRef}
      containerPadding={20}
      trigger="focus"
    >
      <Popover className="shadow border-0" style={{ minWidth: 350 }}>
        <div className="smu-popup-tb smu-card smu-card ">
          <div className="smu-popup-tb__content">
            <div className="smu-popup-tb__header p-3">
              <SmuBadge color={badgeColor} />
              <span className="title ms-2">{title}</span>
            </div>
            <ul className="smu-popup-tb__body">
              {!noData ? (
                children
              ) : (
                <li className="text-center">
                  <small>No hay notificaciones.</small>
                </li>
              )}
            </ul>
            {!noData && (
              <div className="smu-popup-tb__footer mt-auto">
                <button
                  type="button"
                  className="smu-generic-button py-2 w-100"
                  onClick={() => handleAll()}
                >
                  Ver todas
                </button>
              </div>
            )}
          </div>
        </div>
      </Popover>
    </Overlay>
  );
};

export default SmuPopupTb;
